import { actionConstants } from './actionConstants';
import { get, post, put, _delete } from './method';
import noti from './toast';
import { sortBy } from 'lodash';

export const configureActions = {
  resetCompletedFlag,
  getDepartments,
  getSpecificDepartment,
  createDepartment,
  editDepartment,
  deleteDepartment,
  getDeptSettingsByLocale,
  getDeptSettingsInLogin,
  getDeptSettingByParam,
  departmentSettings,
  getGroups,
  getSpecificGroup,
  createGroup,
  getUsersByGroup,
  assignUsers,
  assignAlerts,
  editGroup,
  deleteGroup,
  getRoles,
  getSpecificRole,
  createRole,
  editRole,
  deleteRole,
  getScheduledReports,
  getSpecificScheduledReport,
  createScheduledReport,
  editScheduledReport,
  deleteScheduledReport,
  getUsers,
  getSpecificUser,
  createUser,
  editUser,
  clearAlarmIndicators,
  getAlarmIndicators,
  getAIsByDept,
  getAIsAlarmMaps,
  configAlarmIndicator,
  createAlarmIndicator,
  deleteAlarmIndicator,
  getRemoteDevices,
  getSpecificRemoteDevice,
  getRDsByDept,
  createRemoteDevice,
  editRemoteDevice,
  deleteRemoteDevice,
  clearSensors,
  getSensorsByDept,
  getSensorsMVByGroup,
  getSensorsBySensorType,
  atRest,
  inOperation,
  disableSensor,
  enableSensor,
  clearSensorTypes,
  getSensorTypes,
  getSpecificSensorType,
  getSensorTypesByGroup,
  getSensorTypesByScheduled,
  getSensorTypesByReports,
  createSensorType,
  editSensorType,
  deleteSensorType,
  getVCP,
  overrideVCP,
  normalVCP,
};

function resetCompletedFlag() {
  return (dispatch) => {
    dispatch({ type: actionConstants.RESET_COMPLETED_FLAG });
  };
}

function getDepartments() {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_QUERY });
    return await get('app/departments?Sorting=name%20asc&MaxResultCount=1000')
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_DEPARTMENTS_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_QUERY });
        return resp.items;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_DEPARTMENTS_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_QUERY });
        throw error.response.data.error.message;
      });
  };
}

function getSpecificDepartment(id) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_QUERY });
    return await get(`app/departments/${id}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_DEPARTMENT_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_QUERY });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_DEPARTMENT_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_QUERY });
        throw error.response.data.error.message;
      });
  };
}

function createDepartment(_params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    return await post('app/departments', params)
      .then((resp) => {
        noti.success('Department is created');
        dispatch({
          type: actionConstants.CREATE_DEPARTMENT_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.CREATE_DEPARTMENT_FAILURE,
          data: error.response.data.error.message,
        });
      });
  };
}

function editDepartment(departmentId, _params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    dispatch({ type: actionConstants.CLEAR_ERROR });
    return await put(`app/departments/${departmentId}`, params)
      .then((resp) => {
        noti.success('Department is updated');
        dispatch({
          type: actionConstants.EDIT_DEPARTMENT_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.EDIT_DEPARTMENT_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function deleteDepartment(departmentId) {
  return async (dispatch, getState) => {
    dispatch({ type: actionConstants.CLEAR_ERROR });
    return await _delete(`app/departments/${departmentId}`)
      .then((resp) => {
        noti.success('Department is deleted');
        dispatch({
          type: actionConstants.DELETE_DEPARTMENT_SUCCESS,
        });
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.DELETE_DEPARTMENT_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getDeptSettingsByLocale(deptId, locale = 'en_US', isSet = false) {
  return async (dispatch) => {
    return await get(`app/departments/${deptId}/settings/by-locale/${locale}`)
      .then((resp) => {
        if (isSet)
          localStorage.setItem('departmentSettings', JSON.stringify(resp));
        dispatch({
          type: actionConstants.GET_DEPT_SETTINGS_BY_LOCALE_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_DEPT_SETTINGS_BY_LOCALE_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getDeptSettingsInLogin(locale = 'en_US') {
  return async (dispatch) => {
    return await get(`app/departments/currentSettings/by-locale/${locale}`)
      .then((resp) => {
        localStorage.setItem('departmentSettings', JSON.stringify(resp));
        dispatch({
          type: actionConstants.GET_DEPT_SETTINGS_BY_LOCALE_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_QUERY });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_DEPT_SETTINGS_BY_LOCALE_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getDeptSettingByParam(deptId, param) {
  return async (dispatch) => {
    return await get(`app/departments/${deptId}/settings/by-parameter/${param}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_DEPT_SETTINGS_BY_PARAM_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_DEPT_SETTINGS_BY_PARAM_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function departmentSettings(id, _params) {
  function convertToString(value) {
    if (typeof value === 'string') {
      return value;
    } else if (value === null) {
      return '';
    } else {
      return value.toString();
    }
  }
  const p = [];
  Object.keys(_params).forEach((k) => {
    if (k === 'LocaleName' || k === 'name' || k === 'description') {
      return;
    }
    if (_params.hasOwnProperty(k)) {
      if (k === 'MainMapName' && _params[k] === '<No Map Selected>') {
        p.push({
          value: '',
          parameter: k,
        });
      } else if (
        k === 'SecondaryMapName' &&
        _params[k] === '<No Map Selected>'
      ) {
        p.push({
          value: '',
          parameter: k,
        });
      } else {
        p.push({
          value: convertToString(_params[k]),
          parameter: k,
        });
      }
    }
  });

  let params = {
    body: p,
  };
  return async (dispatch) => {
    return await put(`app/departments/settings/${id}`, params)
      .then((resp) => {
        noti.success('Department is set');
        dispatch({
          type: actionConstants.DEPARTMENT_SETTINGS_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.DEPARTMENT_SETTINGS_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getGroups() {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_QUERY });
    dispatch({ type: actionConstants.CLEAR_ERROR });
    dispatch({ type: actionConstants.INIT_STATE });
    return await get('app/groups?Sorting=name%20asc&MaxResultCount=1000')
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_GROUPS_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_GROUPS_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getSpecificGroup(id) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.INIT_STATE });
    dispatch({ type: actionConstants.START_QUERY });
    return await get(`app/groups/${id}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_GROUP_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_QUERY });
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_GROUP_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_QUERY });
        throw error.response.data.error.message;
      });
  };
}

function createGroup(_params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    return await post('app/groups', params)
      .then((resp) => {
        noti.success(`Group is created`);
        dispatch({
          type: actionConstants.CREATE_GROUP_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.CREATE_GROUP_FAILURE,
          data: error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getUsersByGroup(groupId) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.INIT_STATE });
    dispatch({ type: actionConstants.START_QUERY });
    return await get(`app/groups/${groupId}/users`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_USERS_BY_GROUP_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.message);
        dispatch({
          type: actionConstants.GET_USERS_BY_GROUP_FAILURE,
          data: error.message,
        });
      });
  };
}

function assignUsers(groupId, assignUserIds, unassignUserIds) {
  let assignParams = {
    body: assignUserIds,
  };
  return async (dispatch) => {
    return await put(`app/groups/${groupId}/users/assign`, assignParams)
      .then(async (resp) => {
        let unassignParams = {
          body: unassignUserIds,
        };
        await put(`app/groups/${groupId}/users/remove`, unassignParams)
          .then(() => noti.success('Users assignment is updated '))
          .catch((error) => {
            noti.error(error.response.data.error.message);
            dispatch({
              type: actionConstants.UNASSIGN_USERS_FAILURE,
              data: error.message,
            });
            throw error.response.data.error.message;
          });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.ASSIGN_USERS_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function assignAlerts(groupId, _params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    return await put(`app/groups/${groupId}/assign-remotes`, params)
      .then((resp) => {
        noti.success('Alerts assigned');
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.ASSIGN_ALERTS_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function editGroup(id, _params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_SUBMISSION });
    return await put(`app/groups/${id}`, params)
      .then((resp) => {
        noti.success('Group is updated');
        dispatch({
          type: actionConstants.EDIT_GROUP_SUCCESS,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.EDIT_GROUP_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
        throw error.response.data.error.message;
      });
  };
}

function deleteGroup(id) {
  return async (dispatch, getState) => {
    dispatch({ type: actionConstants.START_QUERY });
    return await _delete(`app/groups/${id}`)
      .then((resp) => {
        noti.success('Group is deleted');
        dispatch({
          type: actionConstants.DELETE_GROUP_SUCCESS,
        });
        dispatch({ type: actionConstants.END_QUERY });
        return true;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.DELETE_GROUP_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_QUERY });
        throw error.response.data.error.message;
      });
  };
}

function getRoles() {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_QUERY });
    return await get('identity/roles?Sorting=name%20asc&MaxResultCount=1000')
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_ROLES_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_QUERY });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_ROLES_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_QUERY });
        throw error.response.data.error.message;
      });
  };
}

function getSpecificRole(roleId) {
  return async (dispatch) => {
    return await get(`identity/roles/${roleId}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_ROLE_SUCCESS,
          data: resp,
        });
        return resp;
      })
      .catch((error) => {
        noti.error(error.message);
        dispatch({
          type: actionConstants.GET_ROLE_FAILURE,
          data: error.message,
        });
      });
  };
}

function createRole(_params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    return await post('identity/roles', params)
      .then((resp) => {
        noti.success('Role is created');
        dispatch({
          type: actionConstants.CREATE_ROLE_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.CREATE_ROLE_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function editRole(roleId, _params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    return await put(`identity/roles/${roleId}`, params)
      .then((resp) => {
        noti.success('Role is updated');
        dispatch({
          type: actionConstants.EDIT_ROLE_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.EDIT_ROLE_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function deleteRole(roleId) {
  return async (dispatch, getState) => {
    return await _delete(`identity/roles/${roleId}`)
      .then((resp) => {
        noti.success(`Role is deleted`);
        dispatch({
          type: actionConstants.DELETE_ROLE_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.DELETE_ROLE_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getScheduledReports() {
  return async (dispatch) => {
    return await get('app/scheduledReports?MaxResultCount=1000')
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_SCHEDULED_REPORTS_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_SCHEDULED_REPORTS_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getSpecificScheduledReport(id) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_QUERY });
    return await get(`app/scheduledReports/${id}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_SCHEDULED_REPORT_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_QUERY });
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_SCHEDULED_REPORT_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_QUERY });
        throw error.response.data.error.message;
      });
  };
}

function createScheduledReport(_params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_SUBMISSION });
    return await post('app/scheduledReports', params)
      .then((resp) => {
        noti.success(`Scheduled report is created`);
        dispatch({
          type: actionConstants.CREATE_SCHEDULED_REPORT_SUCCESS,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.CREATE_SCHEDULED_REPORT_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
        throw error.response.data.error.message;
      });
  };
}

function editScheduledReport(id, _params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_SUBMISSION });
    return await put(`app/scheduledReports/${id}`, params)
      .then((resp) => {
        noti.success(`Scheduled report is updated`);
        dispatch({
          type: actionConstants.EDIT_SCHEDULED_REPORT_SUCCESS,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.EDIT_SCHEDULED_REPORT_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
        throw error.response.data.error.message;
      });
  };
}

function deleteScheduledReport(id) {
  return async (dispatch, getState) => {
    return await _delete(`app/scheduledReports/${id}`)
      .then((resp) => {
        noti.success(`Scheduled report is deleted`);
        dispatch({
          type: actionConstants.DELETE_SCHEDULED_REPORT_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.DELETE_SCHEDULED_REPORT_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getUsers() {
  return async (dispatch) => {
    dispatch({ type: actionConstants.INIT_STATE });
    dispatch({ type: actionConstants.START_QUERY });
    return await get('app/users')
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_USERS_CONFIG_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_QUERY });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_USERS_CONFIG_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_QUERY });
        throw error.response.data.error.message;
      });
  };
}

function getSpecificUser(id) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_QUERY });
    return await get(`app/users/${id}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_USER_CONFIG_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_QUERY });
      })
      .catch((error) => {
        noti.error(error.message);
        dispatch({
          type: actionConstants.GET_USER_CONFIG_FAILURE,
          data: error.message,
        });
        dispatch({ type: actionConstants.END_QUERY });
        throw error.response.data.error.message;
      });
  };
}

function createUser(_params) {
  const parseTime = (time) => {
    const hour = new Date(time).getHours();
    const minute = new Date(time).getMinutes();
    return `${hour}:${minute < 10 ? '0' + minute : minute}`;
  };
  let p = Object.assign({}, _params);
  let params = {
    body: {
      ...p,
      workDaysOfWeek: sortBy(p.workDaysOfWeek).join(','),
      startWork: parseTime(p.startWork),
      endWork: parseTime(p.endWork),
    },
  };
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_SUBMISSION });
    return await post('app/users', params)
      .then((resp) => {
        noti.success(`User is created`);
        dispatch({
          type: actionConstants.CREATE_USER_CONFIG_SUCCESS,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.CREATE_USER_CONFIG_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
        throw error.response.data.error.message;
      });
  };
}

function editUser(userId, _params) {
  const parseTime = (time) => {
    const hour = new Date(time).getHours();
    const minute = new Date(time).getMinutes();
    return `${hour}:${minute < 10 ? '0' + minute : minute}`;
  };
  let p = Object.assign({}, _params);
  let params = {
    body: {
      ...p,
      workDaysOfWeek: sortBy(p.workDaysOfWeek).join(','),
      startWork: parseTime(p.startWork),
      endWork: parseTime(p.endWork),
    },
  };
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_SUBMISSION });
    return await put(`app/users/${userId}`, params)
      .then((resp) => {
        noti.success(`User is updated`);
        dispatch({
          type: actionConstants.EDIT_USER_CONFIG_SUCCESS,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.EDIT_USER_CONFIG_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
        throw error.response.data.error.message;
      });
  };
}

function clearAlarmIndicators() {
  return async (dispatch) => {
    dispatch({ type: actionConstants.CLEAR_ALARM_INDICATORS });
  };
}

function getAlarmIndicators() {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_QUERY });
    return await get('app/alarmIndicators')
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_ALARM_INDICATORS_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_QUERY });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_ALARM_INDICATORS_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_QUERY });
        throw error.response.data.error.message;
      });
  };
}

function getAIsByDept(deptId) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_FETCHING });
    return await get(`app/alarmIndicators/by-department/${deptId}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_ALARM_INDICATORS_BY_DEPT_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_FETCHING });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_ALARM_INDICATORS_BY_DEPT_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_FETCHING });
        throw error.response.data.error.message;
      });
  };
}

function getAIsAlarmMaps(id) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_QUERY });
    return await get(`app/alarmIndicators/${id}/alarmMaps`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_ALARM_INDICATORS_ALARM_MAPS_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_QUERY });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_ALARM_INDICATORS_ALARM_MAPS_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_QUERY });
        throw error.response.data.error.message;
      });
  };
}

function configAlarmIndicator(groupId, _params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_SUBMISSION });
    return await post(
      `app/alarmIndicators/${groupId}/alarmMaps/by-sensor`,
      params,
    )
      .then((resp) => {
        noti.success(`Alarm indicator is configured`);
        dispatch({
          type: actionConstants.CONFIG_ALARM_INDICATOR_SUCCESS,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.CONFIG_ALARM_INDICATOR_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
        throw error.response.data.error.message;
      });
  };
}

function createAlarmIndicator(_params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_SUBMISSION });
    return await post('app/alarmIndicators', params)
      .then((resp) => {
        noti.success(`Alarm indicator is created`);
        dispatch({
          type: actionConstants.CREATE_ALARM_INDICATOR_SUCCESS,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.CREATE_ALARM_INDICATOR_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
        throw error.response.data.error.message;
      });
  };
}

function deleteAlarmIndicator(id) {
  return async (dispatch, getState) => {
    return await _delete(`app/alarmIndicators/${id}`)
      .then((resp) => {
        noti.success('Alarm indicator is deleted');
        // dispatch({
        //   type: actionConstants.DELETE_REMOTE_DEVICE_SUCCESS,
        // });
      })
      // .then(() => history.push('/configure/remote-devices'))
      .catch((error) => {
        noti.error(error.response.data.error.message);
        // dispatch({
        //   type: actionConstants.DELETE_REMOTE_DEVICE_FAILURE,
        //   data: error.message,
        // });
        throw error.response.data.error.message;
      });
  };
}

function getRemoteDevices() {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_QUERY });
    return await get('app/remoteStations?MaxResultCount=1000')
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_REMOTE_DEVICES_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_QUERY });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_REMOTE_DEVICES_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_QUERY });
        throw error.response.data.error.message;
      });
  };
}

function getRDsByDept(deptId) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_FETCHING });
    return await get(`app/remoteStations/by-department/${deptId}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_REMOTE_DEVICES_BY_DEPT_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_FETCHING });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_REMOTE_DEVICES_BY_DEPT_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_FETCHING });
        throw error.response.data.error.message;
      });
  };
}

function getSpecificRemoteDevice(id) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_QUERY });
    return await get(`app/remoteStations/${id}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_REMOTE_DEVICE_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_QUERY });
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_REMOTE_DEVICE_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_QUERY });
        throw error.response.data.error.message;
      });
  };
}

function createRemoteDevice(_params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_SUBMISSION });
    return await post('app/remoteStations', params)
      .then((resp) => {
        noti.success('Remote device is created');
        dispatch({
          type: actionConstants.CREATE_REMOTE_DEVICE_SUCCESS,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.CREATE_REMOTE_DEVICE_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
        throw error.response.data.error.message;
      });
  };
}

function editRemoteDevice(id, _params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_SUBMISSION });
    return await put(`app/remoteStations/${id}`, params)
      .then((resp) => {
        noti.success('Remote device is updated');
        dispatch({
          type: actionConstants.EDIT_REMOTE_DEVICE_SUCCESS,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.EDIT_REMOTE_DEVICE_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
        throw error.response.data.error.message;
      });
  };
}

function deleteRemoteDevice(id) {
  return async (dispatch, getState) => {
    return await _delete(`app/remoteStations/${id}`)
      .then((resp) => {
        noti.success('Remote device is deleted');
        dispatch({
          type: actionConstants.DELETE_REMOTE_DEVICE_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.DELETE_REMOTE_DEVICE_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function clearSensors() {
  return async (dispatch) => {
    dispatch({ type: actionConstants.CLEAR_SENSORS });
  };
}

function getSensorsByDept(deptId) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_FETCHING });
    return await get(`app/sensors/by-department/${deptId}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_SENSORS_BY_DEPT_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_FETCHING });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_SENSORS_BY_DEPT_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_FETCHING });
        throw error.response.data.error.message;
      });
  };
}

function getSensorsMVByGroup(groupId) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_FETCHING });
    return await get(`app/sensors/measurementValues/${groupId}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_SENSORS_MV_BY_GROUP_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_FETCHING });
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_SENSORS_MV_BY_GROUP_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_FETCHING });
        throw error.response.data.error.message;
      });
  };
}

function getSensorsBySensorType(sensorTypeId) {
  return async (dispatch) => {
    return await get(`app/sensors/by-sensorType/${sensorTypeId}`)
      .then((resp) => resp)
      .catch((error) => {
        noti.error(error.response.data.error.message);
        throw error.response.data.error.message;
      });
  };
}

function atRest(groupIds) {
  return async (dispatch) => {
    return await put(`app/sensors/atRest?groupIds=${groupIds}`)
      .then(() => {
        noti.success('Sensors is at rest');
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        throw error.response.data.error.message;
      });
  };
}

function inOperation(groupIds) {
  return async (dispatch) => {
    return await put(`app/sensors/inOperation?groupIds=${groupIds}`)
      .then(() => {
        noti.success('Sensors is in operation');
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        throw error.response.data.error.message;
      });
  };
}

function disableSensor(_params, type = 'sensor') {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    return await post(
      `app/sensors/${type === 'group' ? 'disableGroup' : 'disable'}`,
      params,
    )
      .then((resp) => {
        noti.success(`Sensor(s) is disabled`);
        dispatch({
          type: actionConstants.DISABLE_SENSOR_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.DISABLE_SENSOR_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function enableSensor(sensorIds, type = 'sensor') {
  return async (dispatch) => {
    return await post(
      `app/sensors/${type === 'group' ? 'enableGroup' : 'enable'}?${
        type === 'group' ? 'groupIds' : 'sensorIds'
      }=${sensorIds}`,
    )
      .then((resp) => {
        noti.success('Sensor(s) is enabled');
        dispatch({
          type: actionConstants.ENABLE_SENSOR_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.ENABLE_SENSOR_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function clearSensorTypes() {
  return async (dispatch) => {
    dispatch({ type: actionConstants.CLEAR_SENSOR_TYPES });
  };
}

function getSensorTypes() {
  return async (dispatch) => {
    return await get('app/sensorTypes?MaxResultCount=1000')
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_SENSOR_TYPES_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_SENSOR_TYPES_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getSpecificSensorType(id) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_QUERY });
    return await get(`app/sensorTypes/${id}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_SENSOR_TYPE_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_QUERY });
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_SENSOR_TYPE_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_QUERY });
        throw error.response.data.error.message;
      });
  };
}

function getSensorTypesByGroup(groupId) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_FETCHING });
    return await get(`app/sensorTypes/by-group/${groupId}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_SENSOR_TYPES_BY_GROUP_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_FETCHING });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_SENSOR_TYPES_BY_GROUP_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_FETCHING });
        throw error.response.data.error.message;
      });
  };
}

function getSensorTypesByScheduled(groupId) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_FETCHING });
    return await get(`app/sensorTypes/reports/${groupId}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_SENSOR_TYPES_BY_SCHEDULED_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_FETCHING });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_SENSOR_TYPES_BY_SCHEDULED_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_FETCHING });
        throw error.response.data.error.message;
      });
  };
}

function getSensorTypesByReports(groupId) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_FETCHING });
    return await get(`app/sensorTypes/reports/${groupId}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_SENSOR_TYPES_BY_SCHEDULED_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_FETCHING });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_SENSOR_TYPES_BY_SCHEDULED_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_FETCHING });
        throw error.response.data.error.message;
      });
  };
}

function createSensorType(_params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_SUBMISSION });
    return await post('app/sensorTypes', params)
      .then((resp) => {
        noti.success('Sensor is created');
        dispatch({
          type: actionConstants.CREATE_SENSOR_TYPE_SUCCESS,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.CREATE_SENSOR_TYPE_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
        throw error.response.data.error.message;
      });
  };
}

function editSensorType(id, _params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_SUBMISSION });
    return await put(`app/sensorTypes/${id}`, params)
      .then((resp) => {
        noti.success('Sensor type is updated');
        dispatch({
          type: actionConstants.EDIT_SENSOR_TYPE_SUCCESS,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.EDIT_SENSOR_TYPE_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_SUBMISSION });
        throw error.response.data.error.message;
      });
  };
}

function deleteSensorType(id) {
  return async (dispatch, getState) => {
    return await _delete(`app/sensorTypes/${id}`)
      .then((resp) => {
        noti.success(`Sensor type is deleted`);
        dispatch({
          type: actionConstants.DELETE_SENSOR_TYPE_SUCCESS,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.DELETE_SENSOR_TYPE_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getVCP(groupId) {
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_FETCHING });
    return await get(`app/sensors/measurementValues/${groupId}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_VCP_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_FETCHING });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_VCP_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_FETCHING });
        throw error.response.data.error.message;
      });
  };
}

function overrideVCP(sensorId, _params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_FETCHING });
    return await put(`app/sensors/${sensorId}/value/override`, params)
      .then((resp) => {
        dispatch({
          type: actionConstants.OVERRIDE_VCP_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_FETCHING });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.OVERRIDE_VCP_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_FETCHING });
        throw error.response.data.error.message;
      });
  };
}

function normalVCP(sensorId, _params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    dispatch({ type: actionConstants.START_FETCHING });
    return await put(`app/sensors/${sensorId}/value/normal`, params)
      .then((resp) => {
        dispatch({
          type: actionConstants.NORMAL_VCP_SUCCESS,
          data: resp,
        });
        dispatch({ type: actionConstants.END_FETCHING });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.NORMAL_VCP_FAILURE,
          data: error.response.data.error.message,
        });
        dispatch({ type: actionConstants.END_FETCHING });
        throw error.response.data.error.message;
      });
  };
}
